// Per-user landing page options. Paths mirror the sidebar nav (Sidebar.jsx)
// and must stay in sync with LANDING_PAGES in backend/routes/auth.py.
export const LANDING_PAGES = [
  { value: "/ops", label: "Ops Dashboard" },
  { value: "/sales", label: "Sales Dashboard" },
  { value: "/leads", label: "Leads" },
  { value: "/proposals", label: "Proposals" },
  { value: "/clients", label: "Customers" },
  { value: "/work-orders", label: "Work Orders" },
  { value: "/dispatch", label: "Dispatch" },
  { value: "/timesheets", label: "Timesheets" },
  { value: "/purchasing", label: "Purchasing" },
  { value: "/field", label: "Tech" },
  { value: "/map", label: "Map" },
];

// First page the user can actually open when no landing page is saved (e.g. warehouse-only → Purchasing › Receiving).
const FALLBACKS = [
  ["ops.dashboard", "/ops"], ["sales.dashboard", "/sales"], ["ops.work_orders", "/work-orders"], ["sales.proposals", "/proposals"],
  ["sales.customers", "/clients"], ["ops.purchasing", "/purchasing"], ["ops.warehouse", "/purchasing?tab=receiving"],
  ["ops.invoices", "/invoicing"], ["ops.dispatch", "/dispatch"], ["ops.timesheets", "/timesheets"],
];

/** Where this user should land on sign-in / ABS logo click. `can` is the
 *  access-matrix check from useAuth(); the matrix decides, not the role. */
export const resolveLandingPath = (user, can = () => true) => {
  const saved = user?.landing_page === "/" ? "/ops" : user?.landing_page;
  if (saved && LANDING_PAGES.some(p => p.value === saved)) return saved;
  if (!user) return "/field";
  return (FALLBACKS.find(([s]) => can(s, "read")) || [null, "/field"])[1];
};
